export enum UNPROTECTED_ROUTES {
  LOGIN = 'login',
  CREATE_PASSWORD = 'create-password',
  RESET_PASSWORD = 'reset-password',
  FORGOT_PASSWORD = 'forgot-password',
  SESSION_TIMEOUT = 'session-timeout',
}

export const unprotectedRoutesArr = Object.values(UNPROTECTED_ROUTES);
